import { PollingOptions, PollingSubscription } from './PollingSubscription';
import { UserPresenceStore } from './UserPresenceStore';

export class Poller {
  private readonly userPresenceStore = new UserPresenceStore();

  subscribe(request: () => Promise<boolean | void>, options?: Partial<PollingOptions>) {
    return new PollingSubscription(this.userPresenceStore, request, options);
  }
}

export const poller = new Poller();
